export const comments_3257647 = {"data":{"data":[],"links":{}}}